import {
  DataSet,
  Data,
  PropertySet,
  Workbook,
  WorkbookOperational,
  WorkbookPersistent,
  View,
  ViewConfig,
} from "../core/Workbook";
import { dictionaryValueMap } from "../utils/dictionaryUtils";
import { cloneViewConfig } from "./replicate";

/**
 * Functions for copying model objects to a new value object with no shared references
 */

function deepCopyData(data: Data): Data {
  return {
    ...data,
  };
}
function deepCopyProperties(properties: PropertySet): PropertySet {
  return {
    descriptors: { ...properties.descriptors },
    nameToKey: { ...properties.nameToKey },
    keyToName: { ...properties.keyToName },
  };
}
export function deepCopyDataset(dataset: DataSet): DataSet {
  const copy: DataSet = {
    data: deepCopyData(dataset.data),
    properties: deepCopyProperties(dataset.properties),
    id: dataset.id,
    name: dataset.name,
  };
  if (!!dataset.naturalOrder) {
    copy.naturalOrder = { ...dataset.naturalOrder };
  }
  return copy;
}

function deepCopyConfig(config: ViewConfig): ViewConfig {
  return cloneViewConfig(config);
}

export function deepCopyView(view: View): View {
  return {
    id: view.id,
    name: view.name,
    config: deepCopyConfig(view.config),
  };
}

function deepCopyOperational(operational: WorkbookOperational) {
  return {
    nextSheetNumber: operational.nextSheetNumber,
    selectedView: operational.selectedView,
  };
}

function deepCopyWorkbookData(data: WorkbookPersistent): WorkbookPersistent {
  return {
    datasets: dictionaryValueMap(data.datasets, deepCopyDataset),
    viewOrder: [...data.viewOrder],
    views: dictionaryValueMap(data.views, deepCopyView),
  };
}

export function deepCopyWorkbook(workbook: Workbook): Workbook {
  return {
    id: workbook.id,
    name: workbook.name,
    version: workbook.version,
    operational: deepCopyOperational(workbook.operational),
    data: deepCopyWorkbookData(workbook.data),
  };
}
